module.exports = __webpack_public_path__ + "media/media/about/comm-5-06c8a6273f117ab3986d81c0b560a4d9.png";